'use es6';

export const ADS_ADD_ON_UPGRADE_DATA = {
  app: 'ads',
  upgradeProduct: 'ads'
};
export const MARKETING_PRO_UPGRADE_DATA = {
  app: 'ads',
  upgradeProduct: 'marketing-pro'
};
export const MARKETING_STARTER_UPGRADE_DATA = {
  app: 'ads',
  upgradeProduct: 'marketing-starter'
};